module.exports = __webpack_public_path__ + "static/media/con_spa_com.f1cd2dea.png";